import {
  ActionMenu,
  ActionMenuContent,
  ActionMenuItem,
  ActionMenuTriggerType,
  BodyText,
  MenuEmpty,
  MenuInput,
  MenuItems,
  NextLabel,
  TextInput,
} from '@cint/wonderment';
import { useMemo } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { useFetchData } from '@/api/apiHooks';
import { getOptions } from '@/utils/getOptions';
import { DropDownResponse } from '@/utils/types';
import { URLS } from '@/utils/urls';

export function CurrencyAndTextField({
  currencyFieldName,
  amountFieldName,
}: {
  currencyFieldName: string;
  amountFieldName: string;
}) {
  const { data: currenciesData } = useFetchData<DropDownResponse>({
    url: URLS.getCurrencies(),
    staleTime: 10 * 60 * 60 * 1000,
  });
  const currencyListOptions = useMemo(
    () => getOptions(currenciesData?.data),
    [currenciesData?.data]
  );
  const { control } = useFormContext();

  return (
    <div className="flex flex-col gap-2">
      <div className="flex flex-row gap-0.5">
        <NextLabel label="CPA" size="sm" />
        <NextLabel
          label="(Cost per acquisition)"
          className="ds-text-tertiary"
          size="xs"
          isRequired
        />
      </div>
      <div className="flex flex-row gap-2">
        <Controller
          name={currencyFieldName}
          control={control}
          render={({ field }) => (
            <ActionMenu
              closeMenuOnSelect={true}
              triggerProps={{
                type: ActionMenuTriggerType.SelectButton,
                props: {
                  label:
                    currencyListOptions.find(
                      ({ value }) => field.value === value
                    )?.label ?? 'Select currency...',
                },
              }}
            >
              <ActionMenuContent>
                <MenuInput placeholder="Search Currency..." />
                <MenuEmpty>No results.</MenuEmpty>
                <MenuItems>
                  {currencyListOptions.map(({ label, value }) => (
                    <ActionMenuItem
                      key={value}
                      label={label}
                      onClick={() => field.onChange(value)}
                    />
                  ))}
                </MenuItems>
              </ActionMenuContent>
            </ActionMenu>
          )}
        />
        <div className="w-30">
          <Controller
            name={amountFieldName}
            control={control}
            render={({ field, fieldState }) => (
              <TextInput
                {...field}
                placeholder="1.00"
                hasError={!!fieldState.error}
                decoratorTextProps={{ description: fieldState.error?.message }}
              />
            )}
          />
        </div>
      </div>
      <BodyText size="xs">
        Recorded for the recruitment insights report only. Never sent to the ad
        platform or charged.
      </BodyText>
    </div>
  );
}
